import {$qs} from '../../../@shared/ts/dom';
import {GLOBAL} from '../deprecated/global';
import {type CheckoutData} from '../models/CheckoutData';
import {PeachPayCustomer} from '../reducers/peachPayCustomerReducer';
import {isEUCountry} from '../util/country';
import {getLocaleText} from '../util/translation';

export function initVAT(checkoutData: CheckoutData) {
	initVatEvents();

	// Check if self verify is required by vat plugin
	if (checkoutData.vat_self_verify === '1') {
		renderVerifyLocation();
	}

	const vatTypesRequiringID = checkoutData.vat_required === '1' || (checkoutData.vat_required === '2' && isEUCountry(PeachPayCustomer.shipping.country()));

	if (vatTypesRequiringID) {
		renderVATIDInput();
	}
}

function initVatEvents() {
	$qs('#pp-billing-form')?.addEventListener('submit', (event: Event) => {
		event.preventDefault();
		const vatTypesRequiringID = GLOBAL.checkoutData?.vat_required === '1' || (GLOBAL.checkoutData?.vat_required === '2' && isEUCountry(PeachPayCustomer.shipping.country()));

		if (vatTypesRequiringID) {
			renderVATIDInput();
		}
	});
}

/**
 * If vat verification is required this function will render a vat verification textbox in the
 * peachpay modal allowing a deeper integration with EU_Vat
 */
function renderVATIDInput(): void {
	// Since we have to place the div depending on the country sometimes remove old div on new cusotmer checkout page
	const $previousDivs = document.querySelector('#newEUVatDiv');
	$previousDivs?.remove();

	// Create Vat input box
	const $EUVatDiv = document.createElement('div');
	const $vatForm = document.createElement('form');
	const $vatNumber = document.createElement('input');
	$vatNumber.setAttribute('placeholder', 'required');
	$vatNumber.setAttribute('class', 'vat-input');
	const $prompt = document.createElement('span');
	$prompt.innerHTML = 'Vat Number';
	// Appending all the information to div
	$vatForm.append($vatNumber);
	$EUVatDiv.append($prompt);
	$EUVatDiv.append($vatForm);
	$EUVatDiv.setAttribute('id', 'EuVatDiv');
	$EUVatDiv.setAttribute('class', 'color-change-text');

	const $insertionLocation = document.querySelector('#payment-methods');

	$vatNumber.setAttribute('id', 'ppVatNumNew');
	$EUVatDiv.setAttribute('class', 'x-large');
	$EUVatDiv.setAttribute('id', 'newEUVatDiv');
	$insertionLocation?.insertAdjacentElement('afterend', $EUVatDiv);
}

/**
 * Renders a checkbox that allows the user to self verify that their location is indeed the one they reside in
 */
function renderVerifyLocation(): void {
	const $verifyDiv = document.createElement('div');
	const $verifyCheckbox = document.createElement('input');
	const $descriptor = document.createElement('label');
	$verifyCheckbox.setAttribute('id', 'pp_verify_country');
	$verifyCheckbox.setAttribute('type', 'checkbox');
	$verifyCheckbox.setAttribute('value', '1');
	$descriptor.setAttribute('for', 'pp_verify_country');
	$descriptor.innerHTML = getLocaleText('I verify that the country I have entered is the one I reside in');
	$verifyDiv.append($verifyCheckbox);
	$verifyDiv.append($descriptor);
	const $divClone = ($verifyDiv.cloneNode(true)) as Element;

	const $insertLocation2 = $qs('#payment-methods');
	$insertLocation2?.insertAdjacentElement('afterend', $divClone);
}
